/**
 * API client initialization and export module.
 *
 * @module store/api
 * @description Initializes and exports REST and GraphQL API clients with WebSocket support.
 * Provides unified access to all API communication channels used throughout the application.
 *
 * @example
 * import { rest, graph, loadGraphQL } from '@/store/api';
 *
 * // REST API call
 * await rest.get('/bots');
 *
 * // GraphQL query
 * await graph.query({ query: GET_USER });
 *
 * // Initialize GraphQL if not loaded
 * const graphClient = loadGraphQL();
 */
import Vue from "vue";
import "unfetch/polyfill/index.js";
import {
  GRAPHQL_WEBSOCKET_STATE,
  initGraphQL,
  isGraphQLWebsocketConnected,
  isGraphQLWebsocketConnecting,
  listenGraphQLWebsocket,
} from "@/store/graphql";
import { config } from "@/helpers/apiConfig";
import { initREST } from "@/store/rest";

Object.assign(Vue.config, config);

const rest: any = initREST();

let graph: any = null;

/**
 * Initializes and returns the GraphQL client instance.
 *
 * @returns {ApolloClient} Initialized Apollo GraphQL client
 *
 * @example
 * const client = loadGraphQL();
 * const result = await client.query({ query: MY_QUERY });
 */
const loadGraphQL = () => {
  graph = initGraphQL();
  return graph;
};

export {
  loadGraphQL,
  graph,
  rest,
  config,
  initGraphQL,
  GRAPHQL_WEBSOCKET_STATE,
  listenGraphQLWebsocket,
  isGraphQLWebsocketConnected,
  isGraphQLWebsocketConnecting,
};
